var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isUserOnboarded)?_c(_setup.OnboardedHome):(_setup.onboardingStatus === _setup.OnboardingStatus.UNSUPPORTED_COUNTRY)?_c(_setup.UnsupportedCountry):_c(_setup.GlobalHome)
}
var staticRenderFns = []

export { render, staticRenderFns }